/** How long before the set time the match counts as on. */
export const LEAD_MINUTES = 3 * 60;
/**
 * Whether the match is on at `now` (local time). With a time it starts
 * `LEAD_MINUTES` earlier and lasts until the night is over -- a 21:00 match
 * ends after midnight, so until 03:00 the previous day still counts.
 */
export function isScheduledNow(m, now = new Date()) {
    if (m.weekdays.length === 0)
        return false;
    const minutes = now.getHours() * 60 + now.getMinutes();
    const today = now.getDay();
    if (!m.time)
        return m.weekdays.includes(today);
    const [h, mm] = m.time.split(':').map(Number);
    const start = Math.max(0, h * 60 + mm - LEAD_MINUTES);
    if (m.weekdays.includes(today) && minutes >= start)
        return true;
    // After midnight the evening before is still running.
    const yesterday = (today + 6) % 7;
    return m.weekdays.includes(yesterday) && minutes < 3 * 60;
}
export const WEEKDAYS_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
/** "Di, Do · 21:00", in Monday-first order. */
export function scheduleLabel(m) {
    if (m.weekdays.length === 0)
        return '';
    const days = [1, 2, 3, 4, 5, 6, 0].filter((d) => m.weekdays.includes(d)).map((d) => WEEKDAYS_SHORT[d]);
    const label = days.length === 7 ? 'täglich' : days.join(', ');
    return m.time ? `${label} · ${m.time}` : label;
}
//# sourceMappingURL=schedule.js.map